// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__E6s7q","unreadBadge":"styles_unreadBadge__l8Tia","modalContent":"styles_modalContent__2OQMa","modal":"styles_modal__2lPzJ"};